import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { areAllPreviewsSelected } from 'selectors/Selected';
import { clearLevel, selectMultiple } from "reducers/Selected";
import SelectAllCell from "./SelectAllCell";
import { TYPES } from "utils/constants";


export default function SelectAllPreviewsCell() {
	let dispatch = useDispatch();

	let { previews, isAllSelected } = useSelector(state => ({
		previews: state.creativePreviews.items,
		isAllSelected: areAllPreviewsSelected(state),
	}));

	function toggleSelectAll() {
		if (isAllSelected) {
			dispatch(clearLevel(TYPES.PREVIEWS));
		} else {
			dispatch(selectMultiple(previews.map(preview => preview.id), TYPES.PREVIEWS, true));
		}
	}

	return (
		<SelectAllCell className="select-all-previews" column={{ selectAll: toggleSelectAll, isAllSelected }} />
	);
}

SelectAllPreviewsCell.displayName = "SelectAllPreviewsCell";
